import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-management',
  templateUrl: './exam-management.component.html',
  styleUrls: ['./exam-management.component.css']
})
export class ExamManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
